// import uirouter from 'angular-ui-router';
import routing from './generalSettings.route'
import notificationsRouting from './notifications/notifications.route'
import usersRouting from './users/users.route'
//import run from './generalSettings.run';
import GeneralSettingsSrv from './generalSettingsSrv'

// controllers
// notification controllers
import notificationsListCtrl from './notifications/list/notificationsListCtrl'
import customNotificationCtrl from './notifications/custom/customNotificationCtrl'
import notificationRuleCtrl from './notifications/rules/notificationRuleCtrl'
import startMessageNotificationCtrl from './notifications/startMessage/startMessageNotificationCtrl'
import notificationRuleDetailCtrl from './notifications/rules/notificationRuleDetailCtrl'
import customnotificationDetailCtrl from './notifications/custom/customNotificationDetailCtrl'
import startMessageNotificationDetailCtrl from './notifications/startMessage/startMessageNotificationDetailCtrl'
// users controllers
import usersCtrl from './users/list/usersCtrl'
import createUsersCtrl from './users/create/createUsersCtrl'
import createCommitteeCtrl from './users/create/createCommitteeCtrl'
import editCommitteeCtrl from './users/edit/editCommitteeCtrl'
import listCommitteeCtrl from './users/userCommittee/listCommitteCtrl'

// parameters list controllers
import listParamsCtrl from './parameters/listParamsCtrl'
// subjects controllers
import listSubjectCtrl from './subjects/list/listSubjectCtrl'
import createSubjectCtrl from './subjects/create/createSubjectCtrl'
import GlobalConfig from '../../../globals/globalConfig.json'
import run from './generalSettings.run'

export default angular.module('generalSettings.generalSettings', [ GeneralSettingsSrv ])
	.config(routing)
	.config(notificationsRouting)
	.config(usersRouting)
	.run(run)
	.controller('NotificationsListCtrl', notificationsListCtrl)
	.controller('CustomNotificationCtrl', customNotificationCtrl)
	.controller('NotificationRuleCtrl', notificationRuleCtrl)
	.controller('StartMessageNotificationCtrl', startMessageNotificationCtrl)
	.controller('NotificationRuleDetailCtrl', notificationRuleDetailCtrl)
	.controller('CustomNotificationDetailCtrl', customnotificationDetailCtrl)
	.controller('StartMessageNotificationDetailCtrl', startMessageNotificationDetailCtrl)  
	.controller('UsersCtrl', usersCtrl)
	.controller('CreateUsersCtrl', createUsersCtrl)
	.controller('CreateCommitteeCtrl', createCommitteeCtrl)
	.controller('EditCommitteeCtrl', editCommitteeCtrl)
	.controller('listParamsCtrl', listParamsCtrl)
	.controller('ListSubjectCtrl', listSubjectCtrl)
	.controller('createSubjectCtrl', createSubjectCtrl)
	.controller('ListCommitteeCtrl', listCommitteeCtrl)

	.constant('comite', [ {
		title   : 'Comité',
		icon    : 'mdi-image-tune',
		moduleId: GlobalConfig.menuModulesId.committee,
		subMenu : [
			{
				title       : 'Administración de Comité',
				url         : 'generalSettings.users',
				rolesAllowed: [
					GlobalConfig.userRolesIds.comiteeAdmin,
				],
			},
		],

	} ])
	.name



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/index.js